import React, { useState } from "react";
import { Drawer } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { HeaderNavItems } from "../../helperFunction";
import "./styles.scss";

const DrawerMenu = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;
  const handleClick = (navItem) => {
    navigate(`${navItem}`);
    setOpen(false);
  };

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <MenuOutlined onClick={showDrawer} className="menu-line" />
      <Drawer placement="top" onClose={onClose} open={open} className="drawer">
        <div className="drawer-items">
          {HeaderNavItems?.map((e) => {
            return (
              <div
                to={e?.path}
                onClick={() => handleClick(e?.path)}
                className={`contact-link-item ${
                  e?.path === currentPath ? "contact-link-item-active" : ""
                }`}
              >
                {e?.pageName}
              </div>
            );
          })}
        </div>
      </Drawer>
    </>
  );
};
export default DrawerMenu;
